<button class="mytc-button" [id]="id">
  <ng-content />
</button>
